import {InjectionToken} from "@angular/core";
import {LogLevel} from "./services/logger/log-level.enum";
import {LogPublisher} from "./services/logger/logger-providers/log-publisher.interface";

export const LOG_LEVEL = new InjectionToken<LogLevel>("Minimum log level");

export const LOGGER_PROVIDERS = new InjectionToken<LogPublisher[]>(
  "Providers for logging"
);
